import type { ProjectRole } from "./types";

/** Highest first, the backend's ranking (`domain/project_member.py`). */
export const ROLES: ProjectRole[] = ["owner", "admin", "member", "viewer", "annotator"];

export const ROLE_LABEL: Record<ProjectRole, string> = {
  owner: "Owner",
  admin: "Admin",
  member: "Member",
  viewer: "Viewer",
  annotator: "Annotator",
};

const rank = (role: ProjectRole) => ROLES.length - ROLES.indexOf(role);

/** The roles someone with `mine` may hand out: their own and below. */
export function rolesUpTo(mine: ProjectRole): ProjectRole[] {
  return ROLES.filter((r) => rank(r) <= rank(mine));
}

/** May someone with `mine` change or remove a person who holds `theirs`? */
export const outranks = (mine: ProjectRole, theirs: ProjectRole) => rank(theirs) <= rank(mine);

/** What each role may do, in a line, for the role pickers. */
export const ROLE_DESCRIPTION: Record<ProjectRole, string> = {
  owner: "Everything, including deleting the project",
  admin: "Manage people and edit or delete anything",
  member: "Create and run; delete only their own work",
  viewer: "See everything, change nothing",
  annotator: "Only the review queues they're given",
};

/** Is `to` a step down from `from`? Those changes are confirmed first. */
export const demotes = (from: ProjectRole, to: ProjectRole) => rank(to) < rank(from);

/** The role pickers' options: the role, with what it may do as the muted hint. */
export const roleOptions = (roles: ProjectRole[]) =>
  roles.map((r) => ({ value: r, label: ROLE_LABEL[r], hint: ROLE_DESCRIPTION[r] }));
